import { useStoreNext } from "@priolo/jon";
import PhotoDialog from "pages/farms/photo/PhotoDialog";
import PhotosList from "pages/farms/photo/PhotosList";
import { FunctionComponent, useEffect, useMemo } from "react";
import farmSo from "stores/farm";
import attachSo, { PhotoState } from "stores/attachment";
import { Attachment } from "types/Attachment";
import { Uuid } from "types/global";



interface Props {
    cycleUuid?: Uuid
    taskUuid?: Uuid
}
const PhotosTab: FunctionComponent<Props> = ({
    cycleUuid,
    taskUuid,
}) => {

    // STORE
    useStoreNext(attachSo, (state: PhotoState, stateOld: PhotoState) => state.all !== stateOld.all)

    // HOOKs
    useEffect(() => {
        attachSo.fetchAllIfVoid(farmSo.state.select.id)
    }, [])

    const photos = useMemo(() => {
        const fnSort = attachSo.state.sortType == "date"
            ? (a:Attachment, b:Attachment) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            : (a:Attachment, b:Attachment) => a.layer?.layerNumber - b.layer?.layerNumber
        return attachSo.state.all
            .sort(fnSort)
            .filter(photo => 
                (!cycleUuid || photo.cycleUuid == cycleUuid) 
                && (!taskUuid || photo.taskUuid == taskUuid)
            )
    }, [attachSo.state.all, attachSo.state.sortType, cycleUuid])


    // HANDLERS
    const handlePhotoClick = (photo) => {
        attachSo.setSelected(photo)
        attachSo.setDialogOpen(true)
    }

    // RENDER
    return <>
        <PhotosList
            photos={photos}
            onPhotoClick={handlePhotoClick}
        />
    </>

}

export default PhotosTab
